module.exports = __webpack_public_path__ + "static/media/12UNCTAD14.ca9b1d70.jpg";